import c from "class-c";

import CommunityPost from "@repo/kikoff-models/community/CommunityPost";
import ContainerButton from "@repo/ui/buttons/ContainerButton";

import { usePosts } from "~/state/features/posts";

import ChipContainer from "../shared/ChipContainer";

declare namespace PostLike {
  type Props = {
    post: CommunityPost;
    class?: string;
  };
}

function PostLike({ class: className, post }: D<PostLike.Props>) {
  const [posts, setPosts] = usePosts();

  return (
    <ContainerButton
      class="inline"
      // Prevent the click event from bubbling up to the parent
      onClick={(event: Event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
    >
      <ChipContainer class={className}>
        <ContainerButton
          class={c`row-center mr-1 icon:small ${posts.userVoteFor(post.id) === "upvote" && "text:++ color:primary"}`}
          onClick={(event: Event) => {
            event.stopPropagation();
            event.preventDefault();
            setPosts.vote(
              post.id,
              posts.userVoteFor(post.id) === "upvote" ? null : "upvote"
            );
          }}
        >
          
        </ContainerButton>
        <div class="text-center">{post.upvoteCount - post.downvoteCount}</div>
        <ContainerButton
          class={c`row-center ml-1 icon:small ${posts.userVoteFor(post.id) === "downvote" && "text:++ color:error"}`}
          onClick={(event: Event) => {
            event.stopPropagation();
            event.preventDefault();
            setPosts.vote(
              post.id,
              posts.userVoteFor(post.id) === "downvote" ? null : "downvote"
            );
          }}
        >
          
        </ContainerButton>
      </ChipContainer>
    </ContainerButton>
  );
}

export default PostLike;
